import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CustomerService from '@/services/CustomersServices/CustomerService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    id: null,
    submitting: false,
    error: null,
    successOnDelete: '',
};

export const deleteCustomer = createAsyncThunk(
    'customer/deleteCustomer',
    async (customerId, { rejectWithValue }) => {
        try {
            const response = await CustomerService.deleteCustomer(customerId);
            return {
                customerId,
                data: response.data,
            };
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const deleteCustomerSlice = createSlice({
    name: 'deleteCustomer',
    initialState: model,
    reducers: {
        resetDeleteCustomerStateOnError: (state) => {
            state.error = null;
        },
        resetDeleteCustomerStateOnSuccess: (state) => {
            state.successOnDelete = '';
        },
    },
    extraReducers: (builder) => {
        // delete customer
        builder.addCase(deleteCustomer.pending, (state, action) => {
            state.id = action.meta.arg;
            state.submitting = true;
        }).addCase(deleteCustomer.fulfilled, (state) => {
            state.id = null;
            state.submitting = false;
            state.successOnDelete = 'Customer deleted successfully!';
        }).addCase(deleteCustomer.rejected, (state, action) => {
            state.submitting = false;
            state.error = extractError(action);
        });
    },
});

export const {
    resetDeleteCustomerStateOnError,
    resetDeleteCustomerStateOnSuccess,
} = deleteCustomerSlice.actions;

export default deleteCustomerSlice.reducer;
